module.exports = __webpack_public_path__ + "img/q2-lost-son.cec42127.svg";